module.exports = __webpack_public_path__ + "static/media/receipt_black_24dp.fea2dab1.svg";